<template>
  <!-- Dialog Remove Examples -->
  <ib-dialog
    :visible="visible"
    :show-close="false"
    width="440px"
    top="8vh"
    empty-header
  >
    <!-- Dialog Content -->
    <ib-dialog-confirmation-content
      :image="require('@/assets/img/illustrations/delete-note.svg')"
      :title="$t('dialogs.removeExamples.title')"
      :subtitle="$t('dialogs.removeExamples.subtitle')"
      :show-illustration="true"
    />
    <!-- /Dialog Content -->

    <!-- Dialog Footer -->
    <template #footer>
      <ib-divider block class="mb-4" />
      <ib-dialog-footer
        button-size="md"
        :submit-btn-text="$t('delete')"
        :cancel-btn-text="$t('cancel')"
        :loading="loading"
        variant-button="red"
        @cancel="$emit('no')"
        @submit="$emit('yes')"
      />
    </template>
    <!-- /Dialog Footer -->
  </ib-dialog>
  <!-- /Dialog Remove Examples -->
</template>

<script>
export default {
  name: 'DialogRemoveExamples',

  props: {
    visible: {
      default: false,
      type: Boolean
    },

    loading: {
      default: false,
      type: Boolean
    }
  }
}
</script>
